import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  Container,
  Paragraph,
  Divider,
  Button,
  CloseButton,
  Icon
} from "../CancellationModal/Styles";
import ModalActions from "../../redux/reducers/modal.reducer";
import { startInvestFlow } from "../../redux/epics/invest";

const RechargeModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Container>
      <CloseButton
        data-testid="simulator-close-modal"
        onClick={() => dispatch(ModalActions.setConditionalModalState(false))}
      >
        <Icon alt="previous" src="/assets/images/close_2.png" />
      </CloseButton>
      <Paragraph>{`${t("investment.rechargeModalText")}`}</Paragraph>
      <Divider />
      <Button
        data-testid="simulator-recharge-button"
        onClick={() => {
          dispatch(startInvestFlow());
          dispatch(ModalActions.setConditionalModalState(false));
        }}
      >
        {t("investment.rechargeText")}
      </Button>
    </Container>
  );
};

export default RechargeModal;
